// import styled, { keyframes } from 'styled-components';

// import { backgroundStyles } from '../../../styles/backgroundLogin';

// const float = keyframes`
//   0% {
//     transform: translate3d(0, 0, 0) rotate(12deg);
//   }

//   50% {
//     transform: translate3d(16px, -18px, 0) rotate(18deg);
//   }

//   100% {
//     transform: translate3d(0, 0, 0) rotate(12deg);
//   }
// `;

// export const Container = styled.div`
//   position: relative;
//   display: flex;
//   min-height: 100vh;
//   width: 100%;
//   overflow: hidden;
//   background: #07111f;
// `;

// export const Background = styled.div`
//   position: absolute;
//   inset: 0;
//   z-index: 0;

//   ${({ personalizacao }) =>
//     backgroundStyles[personalizacao] || backgroundStyles.assiste}

//   background-position: center;
//   background-size: cover;

//   &::before {
//     content: '';
//     position: absolute;
//     inset: 0;
//     z-index: 1;
//     background: radial-gradient(
//         circle at 12% 16%,
//         rgba(255, 109, 60, 0.34),
//         transparent 30%
//       ),
//       radial-gradient(
//         circle at 86% 78%,
//         rgba(23, 137, 221, 0.28),
//         transparent 34%
//       ),
//       linear-gradient(
//         120deg,
//         rgba(7, 17, 31, 0.96) 0%,
//         rgba(9, 23, 42, 0.9) 42%,
//         rgba(7, 17, 31, 0.68) 100%
//       );
//   }

//   &::after {
//     content: '';
//     position: absolute;
//     inset: 0;
//     z-index: 2;
//     opacity: 0.22;
//     background-image: linear-gradient(
//         rgba(255, 255, 255, 0.06) 1px,
//         transparent 1px
//       ),
//       linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
//     background-size: 72px 72px;
//     mask-image: linear-gradient(
//       90deg,
//       transparent,
//       #000 22%,
//       #000 78%,
//       transparent
//     );
//     pointer-events: none;
//   }

//   @media (max-width: 850px) {
//     background: radial-gradient(
//         circle at top left,
//         rgba(255, 109, 60, 0.26),
//         transparent 34%
//       ),
//       radial-gradient(
//         circle at bottom right,
//         rgba(23, 137, 221, 0.2),
//         transparent 38%
//       ),
//       linear-gradient(135deg, #07111f 0%, #132640 52%, #0a1628 100%);
//     background-size: auto;
//   }
// `;

// export const Content = styled.div`
//   position: relative;
//   z-index: 2;
//   display: grid;
//   grid-template-columns: minmax(390px, 500px) minmax(0, 1fr);
//   align-items: center;
//   gap: clamp(128px, 8vw, 128px);
//   width: 100%;
//   min-height: 100vh;
//   padding: 56px clamp(42px, 6vw, 84px);

//   @media (max-width: 1100px) {
//     grid-template-columns: minmax(380px, 480px) minmax(0, 1fr);
//     gap: 42px;
//     padding: 42px;
//   }

//   @media (max-width: 850px) {
//     display: flex;
//     justify-content: center;
//     padding: 28px;
//   }

//   @media (max-width: 600px) {
//     padding: 20px;
//   }
// `;

// export const Wrapper = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 100%;
// `;

// export const BrandContent = styled.div`
//   bottom: 30px;
//   position: relative;
//   max-width: 660px;
//   color: #fff;

//   &::before {
//     content: '';
//     position: absolute;
//     top: -92px;
//     right: 28px;
//     width: 170px;
//     height: 170px;
//     border-radius: 46px;
//     border: 1px solid rgba(255, 255, 255, 0.16);
//     background: rgba(255, 255, 255, 0.035);
//     animation: ${float} 11s ease-in-out infinite;
//   }

//   &::after {
//     content: '';
//     position: absolute;
//     right: -120px;
//     bottom: -92px;
//     width: 280px;
//     height: 280px;
//     border-radius: 999px;
//     background: radial-gradient(
//       circle,
//       rgba(255, 109, 60, 0.16),
//       transparent 66%
//     );
//     pointer-events: none;
//   }

//   @media (max-width: 850px) {
//     display: none;
//   }
// `;

// export const BrandBadge = styled.span`
//   display: inline-flex;
//   align-items: center;
//   width: fit-content;
//   padding: 9px 15px;
//   border: 1px solid rgba(255, 109, 60, 0.42);
//   border-radius: 999px;
//   color: #ffd4c6;
//   background: rgba(255, 109, 60, 0.14);
//   font-size: 12px;
//   font-weight: 900;
//   letter-spacing: 0.8px;
//   text-transform: uppercase;
//   backdrop-filter: blur(10px);

//   &::before {
//     content: '';
//     width: 8px;
//     height: 8px;
//     margin-right: 9px;
//     border-radius: 50%;
//     background: #ff6d3c;
//     box-shadow: 0 0 0 6px rgba(255, 109, 60, 0.16);
//   }
// `;

// export const BrandTitle = styled.h2`
//   max-width: 650px;
//   margin: 24px 0 18px;
//   color: #fff;
//   font-size: clamp(42px, 5vw, 70px);
//   line-height: 0.96;
//   letter-spacing: -2.6px;
// `;

// export const BrandDescription = styled.p`
//   max-width: 585px;
//   margin: 0;
//   color: rgba(255, 255, 255, 0.76);
//   font-size: 17px;
//   line-height: 1.75;
// `;

// export const FeatureList = styled.div`
//   display: grid;
//   gap: 12px;
//   max-width: 560px;
//   margin-top: 34px;
// `;

// export const FeatureItem = styled.div`
//   position: relative;
//   padding: 17px 18px 17px 48px;
//   border: 1px solid rgba(255, 255, 255, 0.13);
//   border-radius: 20px;
//   background: rgba(255, 255, 255, 0.075);
//   box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08),
//     0 18px 46px rgba(0, 0, 0, 0.1);
//   backdrop-filter: blur(12px);

//   &::before {
//     content: '';
//     position: absolute;
//     top: 19px;
//     left: 18px;
//     width: 14px;
//     height: 14px;
//     border-radius: 5px;
//     background: linear-gradient(135deg, #ff6d3c, #ff9f7d);
//     box-shadow: 0 8px 20px rgba(255, 109, 60, 0.32);
//   }

//   strong {
//     display: block;
//     margin-bottom: 4px;
//     color: #fff;
//     font-size: 14px;
//   }

//   span {
//     display: block;
//     color: rgba(255, 255, 255, 0.66);
//     font-size: 13px;
//     line-height: 1.5;
//   }
// `;

// export const ProductPreview = styled.div`
//   position: absolute;
//   right: 8px;
//   bottom: 190px;
//   width: 310px;
//   padding: 18px;
//   border: 1px solid rgba(255, 255, 255, 0.16);
//   border-radius: 26px;
//   background: rgba(255, 255, 255, 0.09);
//   box-shadow: 0 28px 70px rgba(0, 0, 0, 0.26),
//     inset 0 1px 0 rgba(255, 255, 255, 0.1);
//   backdrop-filter: blur(16px);

//   @media (max-height: 500px) {
//     display: none;
//   }
// `;

// export const PreviewHeader = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   margin-bottom: 16px;

//   span {
//     color: rgba(255, 255, 255, 0.68);
//     font-size: 12px;
//     font-weight: 800;
//   }

//   strong {
//     color: #fff;
//     font-size: 13px;
//     font-weight: 900;
//   }
// `;

// export const PreviewRows = styled.div`
//   display: grid;
//   gap: 10px;
// `;

// export const PreviewRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   min-height: 42px;
//   padding: 0 12px;
//   border-radius: 14px;
//   background: rgba(255, 255, 255, 0.08);

//   span {
//     color: rgba(255, 255, 255, 0.66);
//     font-size: 12px;
//     font-weight: 700;
//   }

//   strong {
//     color: #ffd4c6;
//     font-size: 12px;
//     font-weight: 900;
//   }
// `;

import styled, { keyframes } from 'styled-components';

import { backgroundStyles } from '../../../styles/backgroundLogin';

const float = keyframes`
  0%   { transform: translate3d(0, 0, 0) rotate(12deg); }
  50%  { transform: translate3d(16px, -20px, 0) rotate(18deg); }
  100% { transform: translate3d(0, 0, 0) rotate(12deg); }
`;

const drift = keyframes`
  0%   { transform: translate3d(0, 0, 0) scale(1); }
  50%  { transform: translate3d(-26px, 22px, 0) scale(1.08); }
  100% { transform: translate3d(0, 0, 0) scale(1); }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const sweep = keyframes`
  0%   { left: -10%; opacity: 0; transform: translateY(-50%) rotate(8deg); }
  18%  { opacity: 1; }
  50%  { transform: translateY(-58%) rotate(16deg); }
  82%  { opacity: 1; }
  100% { left: 86%; opacity: 0; transform: translateY(-50%) rotate(8deg); }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  background: #060e1a;
`;

export const Background = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;

  ${({ personalizacao }) =>
    backgroundStyles[personalizacao] || backgroundStyles.assiste}

  background-position: center;
  background-size: cover;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    background: radial-gradient(
        circle at 10% 14%,
        rgba(255, 109, 60, 0.38),
        transparent 32%
      ),
      radial-gradient(
        circle at 88% 80%,
        rgba(23, 137, 221, 0.32),
        transparent 36%
      ),
      radial-gradient(
        circle at 50% 122%,
        rgba(23, 137, 221, 0.18),
        transparent 50%
      ),
      linear-gradient(
        120deg,
        rgba(6, 14, 26, 0.97) 0%,
        rgba(9, 23, 42, 0.9) 44%,
        rgba(6, 14, 26, 0.72) 100%
      );
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 2;
    opacity: 0.2;
    background-image: linear-gradient(
        rgba(255, 255, 255, 0.06) 1px,
        transparent 1px
      ),
      linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
    background-size: 64px 64px;
    -webkit-mask-image: radial-gradient(
      circle at 70% 50%,
      #000 0%,
      #000 52%,
      transparent 84%
    );
    mask-image: radial-gradient(
      circle at 70% 50%,
      #000 0%,
      #000 52%,
      transparent 84%
    );
    pointer-events: none;
  }

  @media (max-width: 850px) {
    background: radial-gradient(
        circle at top left,
        rgba(255, 109, 60, 0.28),
        transparent 36%
      ),
      radial-gradient(
        circle at bottom right,
        rgba(23, 137, 221, 0.22),
        transparent 40%
      ),
      linear-gradient(135deg, #060e1a 0%, #122440 52%, #0a1628 100%);
    background-size: auto;

    &::before,
    &::after {
      content: none;
    }
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: minmax(390px, 500px) minmax(0, 1fr);
  align-items: center;
  gap: clamp(48px, 7vw, 120px);
  width: 100%;
  min-height: 100vh;
  padding: 56px clamp(42px, 6vw, 84px);

  @media (max-width: 1100px) {
    grid-template-columns: minmax(380px, 480px) minmax(0, 1fr);
    gap: 42px;
    padding: 42px;
  }

  @media (max-width: 850px) {
    display: flex;
    justify-content: center;
    padding: 28px;
  }

  @media (max-width: 600px) {
    padding: 20px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const BrandContent = styled.div`
  position: relative;
  bottom: 30px;
  max-width: 660px;
  color: #fff;
  animation: ${fadeUp} 0.9s cubic-bezier(0.22, 1, 0.36, 1) both;

  /* &::before {
    content: '';
    position: absolute;
    top: -92px;
    right: 28px;
    width: 170px;
    height: 170px;
    border-radius: 46px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    background: rgba(255, 255, 255, 0.04);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(4px);
    animation: ${float} 11s ease-in-out infinite;
  } */

  &::after {
    content: '';
    position: absolute;
    right: -120px;
    bottom: -92px;
    width: 300px;
    height: 300px;
    border-radius: 999px;
    background: radial-gradient(
      circle,
      rgba(255, 109, 60, 0.18),
      transparent 66%
    );
    pointer-events: none;
    animation: ${drift} 16s ease-in-out infinite;
  }

  @media (max-width: 850px) {
    display: none;
  }
`;

export const BrandBadge = styled.span`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 9px 15px;
  border: 1px solid rgba(255, 109, 60, 0.42);
  border-radius: 999px;
  color: #ffd4c6;
  background: rgba(255, 109, 60, 0.14);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  backdrop-filter: blur(10px);

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    margin-right: 9px;
    border-radius: 50%;
    background: #ff6d3c;
    box-shadow: 0 0 0 6px rgba(255, 109, 60, 0.16);
  }
`;

/* export const BrandTitle = styled.h2`
  max-width: 650px;
  margin: 24px 0 18px;
  color: #fff;
  font-size: clamp(42px, 5vw, 70px);
  line-height: 0.96;
  letter-spacing: -2.4px;
  text-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
`; */

export const BrandTitle = styled.h2`
  position: relative;
  z-index: 0;
  isolation: isolate;
  max-width: 650px;
  margin: 24px 0 18px;
  color: #fff;
  font-size: clamp(42px, 5vw, 70px);
  line-height: 0.96;
  letter-spacing: -2.4px;
  text-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
  /* color: #fff; */
  animation: ${fadeUp} 0.9s cubic-bezier(0.22, 1, 0.36, 1) both;

  &::before {
    content: '';
    position: absolute;
    z-index: 2;
    top: 50%;
    left: -10%;
    width: 130px;
    height: 130px;
    border-radius: 40px;
    /* border: 1px solid rgba(255, 255, 255, 0.16);
    background: rgba(255, 255, 255, 0.04);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12),
      0 0 60px rgba(255, 109, 60, 0.22); */
    border: 1px solid rgba(255, 255, 255, 0.16);
    background: rgba(255, 255, 255, 0.04);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    transform: translateY(-50%) rotate(8deg);
    /* pointer-events: none; */
    animation: ${sweep} 30s ease-in-out infinite;
  }
`;

export const BrandDescription = styled.p`
  max-width: 585px;
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 17px;
  line-height: 1.75;
`;

export const FeatureList = styled.div`
  display: grid;
  gap: 12px;
  max-width: 560px;
  margin-top: 34px;
`;

export const FeatureItem = styled.div`
  position: relative;
  padding: 17px 18px 17px 48px;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 18px 46px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(12px);
  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),
    border-color 0.3s ease, background 0.3s ease, box-shadow 0.3s ease;
  animation: ${fadeUp} 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;

  &:nth-child(1) {
    animation-delay: 0.15s;
  }
  &:nth-child(2) {
    animation-delay: 0.28s;
  }
  &:nth-child(3) {
    animation-delay: 0.41s;
  }

  &::before {
    content: '';
    position: absolute;
    top: 19px;
    left: 18px;
    width: 14px;
    height: 14px;
    border-radius: 5px;
    background: linear-gradient(135deg, #ff6d3c, #ff9f7d);
    box-shadow: 0 8px 20px rgba(255, 109, 60, 0.32);
    transition: box-shadow 0.3s ease, transform 0.3s ease;
  }

  &:hover {
    transform: translateX(6px);
    border-color: rgba(255, 109, 60, 0.32);
    background: rgba(255, 255, 255, 0.1);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12),
      0 22px 54px rgba(0, 0, 0, 0.18);
  }

  &:hover::before {
    transform: scale(1.12);
    box-shadow: 0 8px 26px rgba(255, 109, 60, 0.55);
  }

  strong {
    display: block;
    margin-bottom: 4px;
    color: #fff;
    font-size: 14px;
  }

  span {
    display: block;
    color: rgba(255, 255, 255, 0.66);
    font-size: 13px;
    line-height: 1.5;
  }
`;

export const ProductPreview = styled.div`
  position: absolute;
  right: 8px;
  bottom: 190px;
  width: 310px;
  padding: 18px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.09);
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.26),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(16px);

  @media (max-height: 500px) {
    display: none;
  }
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  span {
    color: rgba(255, 255, 255, 0.68);
    font-size: 12px;
    font-weight: 800;
  }

  strong {
    color: #fff;
    font-size: 13px;
    font-weight: 900;
  }
`;

export const PreviewRows = styled.div`
  display: grid;
  gap: 10px;
`;

export const PreviewRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 0 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);

  span {
    color: rgba(255, 255, 255, 0.66);
    font-size: 12px;
    font-weight: 700;
  }

  strong {
    color: #ffd4c6;
    font-size: 12px;
    font-weight: 900;
  }
`;
